var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('app-input',{attrs:{"type":"switch"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}}),_vm._v(" "),_c('span',{staticClass:"unit-status d-inline-block ml-n2"},[_vm._v(_vm._s(_vm.value.translated_name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }